import trackCustomerActions, {
  CustomerActionsErrorType,
  CustomerActionsType
} from '../../lib/tracking/trackCustomerActions';

export const trackSuccessfulRegister = (userId: string, anonymousUserId: string): void => {
  trackCustomerActions(
    {
      type: CustomerActionsType.REGISTRATION
    },
    anonymousUserId,
    userId
  );
};

export const trackRegisterError = (errorMessage: string, anonymousUserId: string): void => {
  trackCustomerActions(
    {
      type: CustomerActionsType.ERROR,
      errorType: CustomerActionsErrorType.REGISTRATION,
      errorMessage: errorMessage
    },
    anonymousUserId,
    null
  );
};

export const trackSuccessfulLogin = (userId: string, anonymousUserId: string): void => {
  trackCustomerActions(
    {
      type: CustomerActionsType.LOGIN
    },
    anonymousUserId,
    userId
  );
};

export const trackLoginError = (errorMessage: string, anonymousUserId: string): void => {
  trackCustomerActions(
    {
      type: CustomerActionsType.ERROR,
      errorType: CustomerActionsErrorType.LOGIN,
      errorMessage: errorMessage
    },
    anonymousUserId,
    null
  );
};
